import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AlertService } from '@app/common/basic/services/alert.service';
import { IErrorResponseBody } from '@app/core/models/http';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal/public_api';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CORE_API_ROUTES } from '../configs/api-routes';
import { Logout } from '../store/session/session.actions';

@Injectable()
export class UserInactiveErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store, private alertService: AlertService, @Inject(CORE_API_ROUTES) private apis) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: IErrorResponseBody) => {
        const { status, message } = error;
        if (req.url !== `/api${this.apis.auth.login}` && status === 401 && message === 'User is inactivated') {
          this.alertService
            .error({
              message,
              onDismiss: (modalResult: Subject<any>, modalRef: BsModalRef) => {
                modalResult.next();
                modalRef.hide();
              },
            })
            .subscribe(_ => {
              this.store.dispatch([new Logout(), new Navigate(['/login'])]);
            });
        } else {
          return throwError(error);
        }
      }),
    );
  }
}
